import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c46b6c84")

_pushScopeId("data-v-c46b6c84")
const _hoisted_1 = {
  key: 0,
  class: "mt-24 pt-4"
}
const _hoisted_2 = {
  key: 1,
  class: "w-full text-center leading-6 font-medium text-bp-dark dark:text-gray-500 mb-1"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputSplit = _resolveComponent("InputSplit")
  const _component_DefaultButton = _resolveComponent("DefaultButton")
  const _component_BaseAlertComponent = _resolveComponent("BaseAlertComponent")
  const _component_LinkButton = _resolveComponent("LinkButton")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_InputSplit, {
      value: _ctx.pinCode,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pinCode = $event)),
      "input-length": _ctx.pinLength,
      "input-id": "Secure Code",
      onSubmitPinInput: _ctx.verifyPin
    }, null, 8, ["value", "input-length", "onSubmitPinInput"]),
    (_ctx.pinCode.length >= _ctx.pinLength && !_ctx.isVerifying && _ctx.showVerifyPinButton)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_DefaultButton, {
            "button-text": _ctx.$t('modal.SubscribeDialog.goForward'),
            "button-color": "bg-bp-light",
            "button-disabled": _ctx.pinCode.length < _ctx.pinLength,
            "button-hover": "hover:bg-bp-light",
            "button-width": "w-auto",
            "button-x-margin": "mx-auto",
            "button-type": "button",
            onClick: _ctx.verifyPin
          }, null, 8, ["button-text", "button-disabled", "onClick"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isVerifying)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_ctx.resendSuccessfully)
            ? (_openBlock(), _createBlock(_component_BaseAlertComponent, {
                key: 0,
                message: _ctx.$t('activate.mail.resendPin.success'),
                "show-title": true,
                title: "Resend Pin",
                "alert-type": "secondary",
                "css-class": "w-full"
              }, null, 8, ["message"]))
            : _createCommentVNode("", true),
          _createVNode(_component_LinkButton, {
            "button-text": _ctx.$t('activate.mail.resendPin'),
            "button-color": "bg-transparent",
            "button-hover": "hover:",
            "button-width": "w-full",
            "button-x-margin": "mx-auto",
            "button-type": "button",
            "custom-css": "flex items-center justify-center text-center w-full",
            onClick: _ctx.resendCode
          }, null, 8, ["button-text", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
})